import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ValidationContext from './../../contexts/ValidationContext'

export default class Button extends Component {
  static propTypes = {
    children: PropTypes.node,
    errorClassName: PropTypes.string,
    className: PropTypes.string
  };

  static contextType = ValidationContext;

  render() {
    const { errorClassName, className, ...rest } = this.props;
    const isDisabled = Object.keys(this.context.errors).length;

    return (
      <button
        className={cx({
          [className]: !!className,
          [errorClassName]: isDisabled && errorClassName
        })}
        disabled={isDisabled}
        {...rest}
      >{this.props.children}</button>
    );
  }
}
